import { Button, makeStyles, Modal } from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import AddBoxOutlinedIcon from "@material-ui/icons/AddBoxOutlined";
import CloseIcon from "@material-ui/icons/Close";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import Loader from "qpr-base/ui/components/Loader";
import React, { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import { Else, If, Then } from "react-if";
import { useDashboard } from "../api/useDashboards.hook";
import QPRInputField from "./Dashboard/QPRInputField";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  body: {
    backgroundColor: theme.palette.background.paper,
    padding: "50px 32px 24px",

    width: "50vw",
    maxWidth: "775px",
    maxHeight: "365px",
    minHeight: "365px",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    borderRadius: "15px",
    position: "relative",

    "& .closeIcon": {
      position: "absolute",
      top: "10px",
      background: "#f1f1f2",
      insetInlineEnd: "10px",
      color: "#8d8d8d",
      borderRadius: "50px",
      display: "flex",
      padding: "10px",
      cursor: "pointer",
    },
    "& .title": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      "& .createIcon": {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        "& .bg": {
          display: "flex",
          borderRadius: "50px",
          width: "fit-content",
          position: "absolute",
          padding: "25px",
          marginBottom: "35px",
          zIndex: 1,
        },
        "& svg": {
          width: "50px",
          height: "50px",
          color: "rgb(0,100,216)",
          zIndex: 2,
        },
      },
    },
    "& .actionTitle": {
      color: "rgb(100,100,100)",
      fontSize: "20px",
    },
    "& .separator": {
      width: "100%",
      border: "1px solid #979797",
      opacity: "0.16",
    },
    "& .input": {
      marginBottom: "10px",
      fontSize: "14px",
    },
    "& .actions": {
      display: "flex",
      gap: "23px",
      marginTop: "24px",
      "& button": {
        borderRadius: "20px",
        border: "1px solid #e7e7e7",
        width: "155px",
        height: "40px",
        fontSize: "12px",
      },
      "& .createBtn": {
        background: "rgb(0,100,216)",
        color: "white",
      },
      "& .createBtn[disabled]": {
        background: "#cccccc",
        color: "#666666",
      },
      "& .MuiCircularProgress-root": {
        position: "unset",
      },
    },
  },
}));

interface SaveModalProps {
  open: boolean;
  onClose: VoidFunction;
  onAccept: (name: string) => void;
  actionName: string;
  modalTitle: string;
  fieldTitle: string;
  icon?: JSX.Element;
  iconBgColor?: string;
  showLoadingIndicator?: boolean;
  initialValue?: string;
}

const SaveModal: FunctionComponent<SaveModalProps> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const ctx = useAppContext();
  const { isLoading, data: board } = useDashboard(ctx.elementId);
  const [name, setname] = useState(props.initialValue || "");

  React.useEffect(() => {
    if (board) {
      setname(board.name);
    }
  }, [board]);
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={props.open}
        onClose={props.onClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open}>
          <div className={classes.body}>
            <div className="closeIcon" onClick={props.onClose} aria-hidden>
              <CloseIcon />
            </div>
            <div className="title">
              <div className="createIcon">
                {props.icon ? props.icon : <AddBoxOutlinedIcon />}
                <div
                  className="bg"
                  style={{ background: "rgb(230,230,230)" }}
                />
              </div>
              <h2 className="actionTitle">{props.modalTitle}</h2>
            </div>
            <div className="separator" />
            <QPRInputField
              onChange={(val: any) => setname(val)}
              value={name}
              name="input"
              label={props.fieldTitle}
              className="input"
            />
            <div className="separator" />

            <div className="actions">
              <Button className="cancelBtn" onClick={props.onClose} aria-hidden>
                {t("buttons.Cancel")}
              </Button>
              <If condition={!props.showLoadingIndicator}>
                <Then>
                  <Button
                    className="createBtn"
                    onClick={() => props.onAccept(name)}
                    aria-hidden
                    disabled={name.length === 0}
                  >
                    {props.actionName}
                  </Button>
                </Then>
                <Else>
                  {props.showLoadingIndicator}
                  <Loader />
                </Else>
              </If>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default SaveModal;
